import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  as: Tag = 'h2'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <div className={`max-w-3xl ${alignment}`} data-id="element-231" data-mp="3k29jy6e1o6za">
      {eyebrow ? <p className="mb-3 text-sm font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-232" data-mp="bloirbrnmi6q">
          {eyebrow}
        </p> : null}
      <Tag className="text-3xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl lg:text-[3.25rem]" data-id="element-233" data-mp="glavlk3klwf0">
        {title}
      </Tag>
      {subtitle ? <p className="mt-5 text-base leading-relaxed text-neutral-400 sm:text-lg" data-id="element-234" data-mp="6sc49ugovrrp">
          {subtitle}
        </p> : null}
    </div>;
}